import { useValidateSnippetReferencesInContent } from './useValidateSnippetReferencesInContent';
import { useValidateHandlebarsSyntaxInContent } from './useValidateHandlebarsSyntaxInContent';

export const useValidateClauseContent = () => {
  const validateHandlebarsSyntaxInContent = useValidateHandlebarsSyntaxInContent();
  const validateSnippetReferencesInContent = useValidateSnippetReferencesInContent();
  return (content = '') =>
    validateHandlebarsSyntaxInContent(content) || validateSnippetReferencesInContent(content);
};
